
<div>
  <panel-block v-if="selectedObjectModelAction.can(ObjectModelActionCapability.labelable)" id="pn-name">
    <panel-item>
      <label :for="selectedObjectModelAction.idForProp('label')">Action Name</label>
      <expandable-textarea
        :id="selectedObjectModelAction.idForProp('label')"
        v-model="selectedObjectModelAction.label_title"
        placeholder="Enter action name..."></expandable-textarea>
    </panel-item>
  </panel-block>

  <panel-block v-if="selectedObjectModelAction.can(ObjectModelActionCapability.formLinkable)" id="pn-linked-form">
    <panel-item>
      <label :for="selectedObjectModelAction.idForProp('linked_form_id')" class="a-select-label">Form to Fill</label>
      <a-select
        v-model="linkedForm"
        bind-by-object
        :options="linkedFormVSelectOptions"
        compress
        :id="selectedObjectModelAction.idForProp('linked_form_id')"
        placeholder="Search forms..."></a-select>
    </panel-item>
  </panel-block>

  <panel-block v-if="selectedObjectModelAction.can(ObjectModelActionCapability.runProcessable)" id="pn-process-flow">
    <panel-item>
      <label :for="selectedObjectModelAction.idForProp('linked_process_flow_id')">Process</label>
      <a-select
        placeholder="Select Process..."
        v-model="linkedProcessFlow"
        compress
        bind-by-object
        :id="selectedObjectModelAction.idForProp('linked_process_flow_id')"
        :options="linkedProcessFlowVSelectOptions"></a-select>
      <button v-if="selectedObjectModelAction.linked_process_flow_id"
              id="configure-process-flow"
              class="btn grey-to-blue full-sz"
              @click="showProcessModal">
        Configure
      </button>
      <view-configure-process-flow-modal
        @toggle-modal="hideModal(vueModalID.configureObjectModelProcessFlow)"
        v-if="modalStateFor(vueModalID.configureObjectModelProcessFlow).isVisible"
        :state="modalStateFor(vueModalID.configureObjectModelProcessFlow)"
        :index="vueModalID.configureObjectModelProcessFlow"
        :parentModel="selectedObjectModelAction"
        :object-model="selectedObjectModel"
        :process-flow="linkedProcessFlow">
      </view-configure-process-flow-modal>
    </panel-item>
  </panel-block>

  <panel-block v-if="selectedObjectModelAction.can(ObjectModelActionCapability.documentLinkable)" id="pn-linked-document">
    <panel-item>
      <label :for="selectedObjectModelAction.idForProp('linked_document_id')" class="a-select-label">Choose a document</label>
      <a-select
        v-model="linkedDocument"
        bind-by-object
        :options="linkedDocumentVSelectOptions"
        compress
        :id="selectedObjectModelAction.idForProp('linked_document_id')"
      ></a-select>
    </panel-item>
  </panel-block>

  <panel-block v-if="selectedObjectModelAction.can(ObjectModelActionCapability.accountLinkable)" id="pn-linked-account">
    <panel-item>
      <label :for="selectedObjectModelAction.idForProp('linked_account_relationship_id')" class="a-select-label">
        Assign to which account relationship?
      </label>
      <a-select
        v-model="linkedAccountRelationship"
        bind-by-object
        :options="linkedAccountRelationshipVSelectOptions"
        compress
        placeholder="Select account relationship..."
        :id="selectedObjectModelAction.idForProp('linked_account_relationship_id')"
      ></a-select>
    </panel-item>
  </panel-block>
</div>
